import { api } from "@/lib/api";
import type {
  ApiResponse,
  Category,
  MainArea,
  CourseListItem,
} from "@learn-me/types";

interface CategoryWithCourses {
  category: Category;
  courses: CourseListItem[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const categoriesApi = {
  // Listar todas las categorías
  async list(): Promise<Category[]> {
    const response = await api.get<ApiResponse<Category[]>>("/categories");
    return response.data.data!;
  },

  // Obtener las 3 áreas de formación principales
  async getMainAreas(): Promise<MainArea[]> {
    const response = await api.get<ApiResponse<MainArea[]>>(
      "/categories/main-areas",
    );
    return response.data.data!;
  },

  // Obtener una categoría por slug
  async getBySlug(slug: string): Promise<Category> {
    const response = await api.get<ApiResponse<Category>>(
      `/categories/${slug}`,
    );
    return response.data.data!;
  },

  // Obtener cursos de una categoría
  async getCourses(
    slug: string,
    page = 1,
    limit = 12,
  ): Promise<CategoryWithCourses> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    const response = await api.get<ApiResponse<CategoryWithCourses>>(
      `/categories/${slug}/courses?${params}`,
    );
    return response.data.data!;
  },

  // ADMIN: Crear categoría
  async create(data: {
    name: string;
    description?: string;
    iconUrl?: string;
    isMainArea?: boolean;
    position?: number;
  }): Promise<Category> {
    const response = await api.post<ApiResponse<Category>>("/categories", data);
    return response.data.data!;
  },

  // ADMIN: Actualizar categoría
  async update(
    id: string,
    data: {
      name?: string;
      description?: string;
      iconUrl?: string;
      isMainArea?: boolean;
      position?: number;
    },
  ): Promise<Category> {
    const response = await api.put<ApiResponse<Category>>(
      `/categories/${id}`,
      data,
    );
    return response.data.data!;
  },

  // ADMIN: Eliminar categoría
  async delete(id: string): Promise<void> {
    await api.delete(`/categories/${id}`);
  },
};
